module.exports = __webpack_public_path__ + "static/img/skin.efa2660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/organs/skin.png
// module id = tb7i
// module chunks = 1